"use client";

import React from "react";
import type { IconProps } from "@/components/icons/icons-utils/icon-props";
import { useIconLayout } from "@/components/icons/icons-utils/use-icon-layout";

// MARK: Role
/**
 * Role icon — add SVG markup inside the root `<svg>`.
 *
 * **Reuse scope:** Project-wide — `@/components/icons` registry.
 */
export const RoleSolid: React.FC<IconProps> = (props) => {
    const { resolved_width, resolved_height, effective_stroke_width, className, svg_style, rest } = useIconLayout(props);

    return (
        <svg
            viewBox="0 0 24 24"
            width={resolved_width}
            height={resolved_height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={svg_style}
            strokeWidth={effective_stroke_width}
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            {...rest}
        >
            <path d="M9.9651 2.12378C11.0562 0.923581 12.9437 0.923583 14.0348 2.12379L21.3319 10.1506C22.2855 11.1995 22.2855 12.8014 21.3319 13.8502L14.0348 21.877C12.9438 23.0772 11.0562 23.0772 9.9651 21.877L2.66806 13.8502C1.71451 12.8014 1.71449 11.1995 2.66804 10.1506L9.9651 2.12378Z" fill="#000000"></path>
        </svg>
    );
};

RoleSolid.displayName = "RoleSolid";
